var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPageLayout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(21,27,38,.75)",
    viewBox: "0 0 24 24",
    title: "page_layout",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MultiColorIcon-path--fadedBlack",
    d: "M19,12V3H5v9H19z M6,11l5-5l3,3l1-1l3,3H6z M17,6c0.6,0,1-0.4,1-1s-0.4-1-1-1s-1,0.4-1,1S16.4,6,17,6z M18,19 c0.6,0,1,0.4,1,1s-0.4,1-1,1h-8c-0.6,0-1-0.4-1-1s0.4-1,1-1H18z M18,15c0.6,0,1,0.4,1,1s-0.4,1-1,1h-8c-0.6,0-1-0.4-1-1s0.4-1,1-1 H18z M5,16c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S5,16.6,5,16z M5,20c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S5,20.6,5,20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "MultiColorIcon-path--white",
    d: "M11,6l-5,5h12l-3-3l-1,1L11,6z M18,5c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S18,4.4,18,5z M3,22c0,1.1,0.9,2,2,2 h14c1.1,0,2-0.9,2-2V2c0-1.1-0.9-2-2-2H5C3.9,0,3,0.9,3,2V22z M19,3v9H5V3H19z M19,20c0-0.6-0.4-1-1-1h-8c-0.6,0-1,0.4-1,1 s0.4,1,1,1h8C18.6,21,19,20.6,19,20z M19,16c0-0.6-0.4-1-1-1h-8c-0.6,0-1,0.4-1,1s0.4,1,1,1h8C18.6,17,19,16.6,19,16z M6,15 c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S6.6,15,6,15z M6,19c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S6.6,19,6,19z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLayout);
export default __webpack_public_path__ + "static/media/page_layout.424412ed.svg";
export { ForwardRef as ReactComponent };